import * as BranchioConstants from './constants';
import * as D from './deps';
import BranchioWatchers from './sagas/watchers';
import * as BranchioUtils from './utils';

export default D.createDomainModule({
  name: 'branchio',
  actions: {},
  utils: BranchioUtils,
  constants: BranchioConstants,
  components: {},
  selectors: {},
  reducer: null,
  onLoad() {},
  onStart() {
    this.registeredHandlers = D.registerHandlers(BranchioWatchers);
  },
  onStop() {
    D.removeAndStopHandlers(this.registeredHandlers, this.name);
  },
});
